import React from "react";
import { inject, observer } from "mobx-react";
import OrientationMarker from "component/molecules/orientationMarker";

@inject("toolbarStore")
@observer
class OrientationMarkerContainer extends React.PureComponent {
  render() {
    const { toolbarStore } = this.props;
    const {
      rowCosines,
      columnCosines,
      hflip,
      vflip,
      rotation,
      //frameRange,
      frameRangeMin,
      frameRangeMax,
      styles,
      ...props
    } = this.props;
    const isShow = toolbarStore.isShowDCMDescription();
    if (isShow === true)
      return (
        <OrientationMarker
          rowCosines={rowCosines}
          columnCosines={columnCosines}
          hflip={hflip}
          vflip={vflip}
          frameRange={{ min: frameRangeMin, max: frameRangeMax }}
          rotation={rotation}
          styles={styles}
          {...props}
        />
      );
    else return "";
  }
}

export default OrientationMarkerContainer;
